function normalizeInlineText(value) {
  return typeof value === "string" ? value.trim() : "";
}

const SAVED_PLANNING_VIEW_ACTIONS = new Set([
  "segment_reorder", "update_truck_time_settings", "update_truck_start_time",
  "update_truck_driver_name",
  "protect_truck", "unprotect_truck", "protect_truck_orders", "unprotect_truck_orders",
  "set_truck_preload_time", "clear_truck_preload_time",
  "enable_truck_overtime", "disable_truck_overtime",
  "enable_truck_dispatch", "disable_truck_dispatch",
  "enable_truck_dompeur_mixed_load", "disable_truck_dompeur_mixed_load",
  "publish_driver_portal_routes", "unpublish_driver_portal_routes",
  "create_truck_incident", "update_truck_incident", "delete_truck_incident",
  "reassign_truck_orders", "optimize_truck_routes", "recalculate_truck_route",
]);

export function requiresSavedPlanningViewForMutation(actionName, requestHeaders) {
  return SAVED_PLANNING_VIEW_ACTIONS.has(actionName) && requestHeaders?.Prefer !== "return=minimal";
}

export function isPortalOnlyPlanningMutationResult(actionName, payload) {
  return actionName === "unpublish_driver_portal_routes"
    && payload?.planning_snapshot_available === false
    && Boolean(payload?.portal_publications)
    && !Array.isArray(payload?.result_payload?.assignments);
}

export function isCoherentPlanningResult(payload, { dispatchDate, dispatchPeriod }) {
  const revision = normalizeInlineText(payload?.runtime_revision);
  return Boolean(revision && revision.length <= 512
    && Array.isArray(payload?.assignments)
    && (payload.dispatch_date || payload.planning_summary?.dispatch_date) === dispatchDate
    && (payload.dispatch_period || payload.planning_summary?.dispatch_period) === dispatchPeriod);
}

export function collectDeliveryAssignmentIds(resultPayload, deliveryId) {
  const safeDeliveryId = normalizeInlineText(deliveryId);
  if (!safeDeliveryId || !resultPayload || typeof resultPayload !== "object" || Array.isArray(resultPayload)) {
    return [];
  }

  const assignmentIds = new Set();
  (Array.isArray(resultPayload.assignments) ? resultPayload.assignments : []).forEach((assignment) => {
    const assignmentId = normalizeInlineText(assignment?.truck_id);
    if (!assignmentId) {
      return;
    }

    let hasDelivery = (Array.isArray(assignment?.delivery_items) ? assignment.delivery_items : [])
      .some((item) => normalizeInlineText(item?.delivery_id) === safeDeliveryId);

    if (!hasDelivery) {
      hasDelivery = (Array.isArray(assignment?.operational_steps) ? assignment.operational_steps : [])
        .some((step) => normalizeInlineText(step?.delivery_id) === safeDeliveryId);
    }

    if (!hasDelivery) {
      hasDelivery = (Array.isArray(assignment?.trips) ? assignment.trips : []).some((trip) => (
        (Array.isArray(trip?.clients) ? trip.clients : [])
          .some((client) => normalizeInlineText(client?.delivery_id) === safeDeliveryId)
        || (Array.isArray(trip?.operational_steps) ? trip.operational_steps : [])
          .some((step) => normalizeInlineText(step?.delivery_id) === safeDeliveryId)
      ));
    }

    if (hasDelivery) {
      assignmentIds.add(assignmentId);
    }
  });

  return [...assignmentIds];
}

export function isDeliveryMovePayloadSynced({
  actionName,
  body = null,
  deliveryId = "",
  resultPayload = null,
} = {}) {
  if (normalizeInlineText(actionName) !== "move_delivery") {
    return true;
  }

  const targetTruckId = normalizeInlineText(body?.target_truck_id);
  if (!targetTruckId || !deliveryId) {
    return true;
  }

  const assignmentIds = collectDeliveryAssignmentIds(resultPayload, deliveryId);
  return assignmentIds.length === 1 && assignmentIds[0] === targetTruckId;
}
